<template>
  <v-row justify="center">
    <v-dialog v-model="dialog" persistent max-width="1400px">
      <v-toolbar class="headline" color="primary" dark>物件明細</v-toolbar>
      <v-form ref="proDialogForm" v-model="valid" lazy-validation>
        <v-card class="Detail">
          <v-row>
            <v-col cols="5">
              <v-card outlined class="proCard" v-show="buildingDetailUpdateFlg">
                <v-row style="padding-top: 3%">
                  <v-col cols="3">
                    <div class="proGroup">物件グループ</div>
                  </v-col>
                  <v-col cols="8">
                    <ryou-select v-model="selectGroup" :value="selectGroup" :items="buildGroupItems"
                      :itemText="'code_text'" :itemValue="'code_value'" :rules="buildGroupRules">
                    </ryou-select>
                  </v-col>
                </v-row>
              </v-card>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="5">
              <ryou-input v-model="model.building_name" :value="model.building_name" :label="'物件名'"
                :rules="buildNameRules" :maxlength="15">
              </ryou-input>
            </v-col>
            <v-col cols="5">
              <ryou-input v-model="model.building_address" :value="model.building_address" :label="'住所'"
                :rules="addressRules" :maxlength="45">
              </ryou-input>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="4">
              <ryou-input v-model="model.building_breadth" :value="model.building_breadth" :label="'物件広さ'"
                :rules="breadthRules" :maxlength="7">
              </ryou-input>
            </v-col>
            <v-col cols="2">
              <ryou-radio v-model="model.tubo_flg" :value="model.tubo_flg" :items="radioItems" :rules="buildGrRules">
              </ryou-radio>
            </v-col>
            <v-col cols="3">
              <ryou-radio v-model="model.room_daily_class" :value="model.room_daily_class" :items="discountItem"
                :label="'部屋日割区分'" :rules="buildGrRules"></ryou-radio>
            </v-col>
            <v-col cols="3">
              <ryou-radio v-model="model.parking_daily_class" :value="model.parking_daily_class" :items="parkingItem"
                :label="'駐車場日割区分'" :rules="buildGrRules"></ryou-radio>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="4">
              <ryou-date-format v-model="building_const_date" :value="building_const_date" :type="'date'"
                :max="new Date().toISOString()" :format="'$1/$2/$3'" :rules="buildingRules" :label="'物件建設日'">
              </ryou-date-format>
            </v-col>
            <v-col cols="1">
              <div class="year">築年数</div>
            </v-col>
            <v-col cols="1">
              <div class="years">{{ this.model.building_age }}</div>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="3">
              <ryou-input v-model="model.resident_association_cost" :value="model.resident_association_cost"
                :label="'自治会費'" :rules="costRules" :maxlength="4">
              </ryou-input>
            </v-col>
            <v-col cols="3">
              <ryou-input v-model="model.tax_rate" :value="model.tax_rate" :label="'消費税率'" :rules="rateRules"
                :maxlength="5">
              </ryou-input>
            </v-col>
            <v-col cols="3">
              <ryou-input v-model="model.reduced_tax_rate" :value="model.reduced_tax_rate" :label="'軽減税率'"
                :rules="reducedRules" :maxlength="5">
              </ryou-input>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <ryou-textarea v-model="model.remark" :value="model.remark" :label="'備考'" :maxlength="250"
                :outlined="true">
              </ryou-textarea>
            </v-col>
          </v-row>
          <v-row>
            <v-spacer></v-spacer>
            <ryou-black-btn :label="'閉じる'" :handlerClick="handleCancel" :iconCls="'mdi-close'">
            </ryou-black-btn>
            <v-spacer></v-spacer>
            <ryou-black-btn :label="'確定'" :handlerClick="handleOk"></ryou-black-btn>
            <v-spacer></v-spacer>
            <ryou-black-btn :label="'削除'" :handlerClick="handleDelete" :iconCls="'mdi-delete'" :disabled="btnCtrl">
            </ryou-black-btn>
            <v-spacer></v-spacer>
          </v-row>
        </v-card>
      </v-form>
    </v-dialog>
    <ryou-confirm ref="confirm"></ryou-confirm>
  </v-row>
</template>
<script>
  import RyouInput from "@/components/formInput/RyouInput.vue";
  import RyouDateFormat from "@/components/formInput/RyouDateFormat.vue";
  import RyouSelect from "@/components/formInput/RyouSelect.vue";
  import RyouRadio from "@/components/formInput/RyouRadio.vue";
  import RyouTextarea from "@/components/formInput/RyouTextarea.vue";
  import RyouBlackBtn from "@/components/formInput/RyouBlackBtn.vue";
  import RyouConfirm from "@/components/dialog/RyouConfirm.vue";
  export default {
    name: "MasterPropertyDialog",
    components: {
      RyouSelect,
      RyouInput,
      RyouRadio,
      RyouDateFormat,
      RyouBlackBtn,
      RyouTextarea,
      RyouConfirm,
    },
    data() {
      return {
        dialog: false,
        valid: true,
        buildingDetailUpdateFlg: false,
        btnCtrl: true,
        selectGroup: "",
        building_const_date: "",
        buildGroupRules: [],
        buildGrRules: [],
        buildNameRules: [],
        addressRules: [],
        breadthRules: [],
        buildingRules: [],
        costRules: [],
        rateRules: [],
        reducedRules: [],
        model: {
          building_id: "",
          building_name: "",
          building_address: "",
          building_breadth: "",
          tubo_flg: "",
          room_daily_class: "",
          parking_daily_class: "",
          building_age: "",
          resident_association_cost: "",
          tax_rate: "",
          reduced_tax_rate: "",
          remark: "",
        },
        radioItems: [
          {
            label: "坪",
            value: "0",
          },
          {
            label: "m2",
            value: "1",
          },
        ],
        discountItem: [
          {
            label: "あり",
            value: "1",
          },
          {
            label: "なし",
            value: "0",
          },
        ],
        parkingItem: [
          {
            label: "有り",
            value: "1",
          },
          {
            label: "なし",
            value: "0",
          },
        ],
      };
    },
    mounted() {
      this.buildGrRules.push(this.GlobalRules.required);
      this.buildNameRules.push(this.GlobalRules.required);
      this.addressRules.push(this.GlobalRules.required);
      this.breadthRules.push(this.GlobalRules.required);
      this.breadthRules.push(this.GlobalRules.number_point_2);
      this.breadthRules.push(this.GlobalRules.numberMax10000);
      this.buildingRules.push(this.GlobalRules.required);
      this.costRules.push(this.GlobalRules.currency);
      this.rateRules.push(this.GlobalRules.required);
      this.rateRules.push(this.GlobalRules.number_point_2);
      this.rateRules.push(this.GlobalRules.numberMax100);
      this.reducedRules.push(this.GlobalRules.required);
      this.reducedRules.push(this.GlobalRules.number_point_2);
      this.reducedRules.push(this.GlobalRules.numberMax100);
    },
    props: {
      url: {
        type: Object,
        required: true,
        default: () => { },
      },
      buildGroupItems: {
        type: Array,
        default: () => [],
        require: true,
      },
    },
    watch: {
      // 物件グループ選択
      building_const_date(value) {
        if (value != null && value != "") {
          let params = {
            building_const_date: value,
          };
          this.getRequest(
            "/masterProperty/buildingAgeGet",
            params,
            this.$store.getters.getUserToken
          ).then((data) => {
            if (data.success) {
              this.model.building_age = data.result.toString();
            }
          });
        }
      },
    },
    methods: {
      add(groupId) {
        this.open();
        this.title = "物件明細新規";
        this.buildingDetailUpdateFlg = false;
        this.buildGroupRules = [];
        this.btnCtrl = true;
        this.selectGroup = groupId;
      },
      edit(record) {
        this.open();
        this.title = "物件明細更新";
        this.buildingDetailUpdateFlg = true;
        this.buildGroupRules.push(this.GlobalRules.required);
        this.btnCtrl = false;
        this.buildingId = record;
        this.buildingInfoGet(record);
      },
      //物件明細検索取得
      buildingInfoGet(record) {
        let params = {
          building_id: record,
        };
        this.getRequest(
          "/masterProperty/buildingInfoDetailGet",
          params,
          this.$store.getters.getUserToken
        ).then((data) => {
          if (data.success) {
            this.model.building_id = data.result[0].building_id;
            this.selectGroup = data.result[0].build_group_id;
            this.model.building_name = data.result[0].building_name;
            this.model.building_address = data.result[0].building_address;
            this.model.building_breadth = data.result[0].building_breadth;
            this.model.tubo_flg = data.result[0].tubo_flg;
            let strDate = new Date(
              Date.parse(data.result[0].building_const_date.replace(/-/g, "/"))
            );
            var y = strDate.getFullYear();
            var m = strDate.getMonth() + 1;
            m = m < 10 ? "0" + m : m;
            var d = strDate.getDate();
            d = d < 10 ? "0" + d : d;
            this.building_const_date = y + "-" + m + "-" + d;
            this.model.building_age = data.result[0].building_age;
            this.model.room_daily_class = data.result[0].room_daily_class;
            this.model.parking_daily_class = data.result[0].parking_daily_class;
            this.model.resident_association_cost =
              data.result[0].resident_association_cost;
            this.model.tax_rate = data.result[0].tax_rate;
            this.model.reduced_tax_rate = data.result[0].reduced_tax_rate;
            this.model.remark = data.result[0].remark;
          }
        });
      },
      //物件削除
      handleDelete() {
        var that = this;
        let params = {
          loginUserId: this.$store.getters.getUserId,
          building_id: this.buildingId,
        };
        this.$refs.confirm
          .open("削除", "削除します。宜しいですか？", { color: "blue" })
          .then((confirm) => {
            if (confirm) {
              this.deleteRequest(
                "/masterProperty/buildingDelete",
                params,
                this.$store.getters.getUserToken
              ).then((res) => {
                if (res.success) {
                  that.$emit("ok");
                  that.close();
                }
              });
            }
          });
        setTimeout(() => { }, 100);
      },
      handleOk() {
        var valid = this.$refs.proDialogForm.validate();
        if (valid) {
          var that = this;
          if (this.buildingDetailUpdateFlg) {
            this.$refs.confirm
              .open("更新", "更新します。宜しいですか？", { color: "info" })
              .then((confirm) => {
                if (confirm) {
                  let updateParams = {
                    loginUserId: this.$store.getters.getUserId,
                    building_id: this.buildingId,
                    build_group_id: this.selectGroup,
                    building_name: this.model.building_name,
                    building_address: this.model.building_address,
                    building_breadth: this.model.building_breadth,
                    tubo_flg: this.model.tubo_flg,
                    building_const_date: this.building_const_date,
                    building_age: this.model.building_age,
                    room_daily_class: this.model.room_daily_class,
                    parking_daily_class: this.model.parking_daily_class,
                    resident_association_cost: this.model
                      .resident_association_cost,
                    tax_rate: this.model.tax_rate,
                    reduced_tax_rate: this.model.reduced_tax_rate,
                    remark: this.model.remark,
                  };
                  this.putRequest(
                    this.url.update,
                    updateParams,
                    this.$store.getters.getUserToken
                  ).then((resp) => {
                    if (resp.success) {
                      that.$emit("ok");
                      that.close();
                    }
                  });
                }
              });
          } else {
            this.$refs.confirm
              .open("登録", "登録します。宜しいですか？", { color: "info" })
              .then((confirm) => {
                if (confirm) {
                  let insertParams = {
                    loginUserId: this.$store.getters.getUserId,
                    build_group_id: this.selectGroup,
                    building_name: this.model.building_name,
                    building_address: this.model.building_address,
                    building_breadth: this.model.building_breadth,
                    tubo_flg: this.model.tubo_flg,
                    building_const_date: this.building_const_date,
                    building_age: this.model.building_age,
                    room_daily_class: this.model.room_daily_class,
                    parking_daily_class: this.model.parking_daily_class,
                    resident_association_cost: this.model
                      .resident_association_cost,
                    tax_rate: this.model.tax_rate,
                    reduced_tax_rate: this.model.reduced_tax_rate,
                    remark: this.model.remark,
                  };
                  this.postRequest(
                    this.url.add,
                    insertParams,
                    this.$store.getters.getUserToken
                  ).then((resp) => {
                    if (resp.success) {
                      that.$emit("ok");
                      that.close();
                    }
                  });
                }
              });
          }
        }
      },
      handleCancel() {
        this.close();
      },
      close() {
        this.dialog = false;
      },
      open() {
        this.dialog = true;
        this.building_const_date = "";
        this.model.building_age = "";
        if (this.$refs.proDialogForm) {
          this.$refs.proDialogForm.reset();
          this.$refs.proDialogForm.resetValidation();
        }
      },
    },
  };
</script>

<style scoped>
  .Detail {
    padding: 35px;
  }

  .proGroup {
    height: 80px;
    padding-top: 10px;
    padding-left: 15px;
  }

  .proCard {
    padding: 0px;
    height: 80px;
  }

  .year {
    padding-left: 30%;
    padding-top: 5%;
  }

  .years {
    width: 80px;
    height: 25px;
    text-align: right;
    background-color: #bdbdbd;
    color: #000;
  }
</style>